import PagesRouter from "./routes";

function App() {
  return <PagesRouter />;
}

export default App;
